module.exports = __webpack_public_path__ + "0b04478001826200a890ec2f5790d831.png";